export default {
  setErrorLogs(state, logs) {
    state.errorLogs = logs;
  },
  appendErrorLogs(state, logs) {
    state.errorLogs = [...state.errorLogs, ...(Array.isArray(logs) ? logs : [])];
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};
